export const notificationBase = {
  insert: 'top' as const,
  container: 'top-right' as const,
  animationIn: ['animate__animated', 'animate__fadeIn'],
  animationOut: ['animate__animated', 'animate__fadeOut']
};

export const notificationDismiss = {
  dismiss: {
    duration: 2000
  }
};
